exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".user-subscriptions .cell-text-wrap{max-width:20rem;overflow-wrap:break-word}.user-subscriptions table tr td:first-child{padding-left:.75rem}.user-subscriptions table tr td:last-child{padding-right:.75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/_notifications.scss
// module id = 18
// module chunks = 0